/** Métadonnées minimales pour construire l’URL du lecteur EduFlow. */
export interface FormationPlayMeta {
  flowId: string;
  creationMode?: 'simple' | 'advanced' | null;
  shortCodePublic?: string | null;
}

/** Lecteur public (visiteur anonyme ou accès ouvert). */
export function formationPublicPlayerPath(flowId: string): string {
  return `/eduflow/flows/${encodeURIComponent(flowId)}/public`;
}

/** Lien court formation démo (`/demo/:shortCodePublic`). */
export function formationDemoShortPath(shortCodePublic: string): string {
  return `/demo/${encodeURIComponent(shortCodePublic)}`;
}

/** URL absolue du lien court démo (origine courante ou fallback production). */
export function formationDemoShortUrl(
  shortCodePublic: string,
  origin = typeof window !== 'undefined' ? window.location.origin : 'https://lyrraone.com',
): string {
  return `${origin.replace(/\/+$/, '')}${formationDemoShortPath(shortCodePublic)}`;
}

/** Lecteur authentifié — à privilégier après achat / page merci. */
export function formationAuthPlayerPath(flowId: string): string {
  return `/eduflow/flows/${encodeURIComponent(flowId)}/play`;
}

/** Prévisualisation formateur/admin : ne compte pas dans les stats apprenant. */
export function formationPreviewPlayerPath(flowId: string): string {
  return `${formationAuthPlayerPath(flowId)}?preview=1`;
}

/**
 * Résout l’URL du lecteur selon le contexte.
 * - `preferAuthenticated` : page merci funnel, espace apprenant (inscription confirmée).
 * - sinon : lien public catalogue / marketing.
 */
export function resolveFormationPlayHref(
  meta: FormationPlayMeta | null | undefined,
  options?: { preferAuthenticated?: boolean },
): string | null {
  const flowId = meta?.flowId?.trim();
  if (!flowId) return null;
  if (options?.preferAuthenticated) {
    return formationAuthPlayerPath(flowId);
  }
  return formationPublicPlayerPath(flowId);
}
